import React, { useState } from "react";
import './trip-create.style.scss';
import {CreateTripForm} from './create-trip-form/create-trip-form';
import { AddStops } from "./add-stops/add-stops";
import MapComponent from "../map-component/map.component";
import { useDispatch } from 'react-redux';
import { setOnMarkerDragEnd, resetAddressFromCache } from "../../actions/trip-create.actions";

export const TripCreateMapRoot = (props) => {
    const {
        onCallBackSetDirections,
        masterCities,
        busesData,
        isTripCityCreated,
        addStop,
        tripScheduleId,
        setShowVerifyPage,
        setHeaderStep,
        stepDataVal,
        selectedSeatNumbers,
        setSelectedSeatNumbers,
        setShowSelectCity,
        showSelectCity,
        setDistance,
        setDuration,
        addStopComponent,
        customClassName,
        childRef,
        setCitiesChanged,
        busFormData
    }= props;

    const dispatch = useDispatch();
    const [enableLocationPick, setEnableLocationPick] = useState(false);
    
    return (
        <div className="trip-root-form">
            <div className={`side-nav ${customClassName}`} >
                <div style= {{alignItems: 'center'}}>
                    {addStop?
                    <AddStops
                        tripScheduleId = {tripScheduleId}
                        setShowVerifyPage = {setShowVerifyPage}
                        setHeaderStep = {setHeaderStep}
                        setEnableLocationPick = {setEnableLocationPick}
                        childRef={childRef}
                    />
                    :<CreateTripForm
                        onCallBackSetDirections={onCallBackSetDirections}
                        masterCities = {masterCities}
                        isTripCityCreated = {isTripCityCreated}
                        busesData = {busesData}
                        tripScheduleId = {tripScheduleId}
                        selectedSeatNumbers={selectedSeatNumbers} 
                        setSelectedSeatNumbers={setSelectedSeatNumbers}
                        setHeaderStep ={setHeaderStep}
                        headerFormPos = {stepDataVal['headerFormPos']}
                        setShowSelectCity = {setShowSelectCity}
                        showSelectCity = {showSelectCity}
                        setDistance={setDistance}
                        setDuration={setDuration}
                        addStopComponent={addStopComponent}
                        setCitiesChanged={setCitiesChanged}
                        methodType="map"
                        busFormData={busFormData}
                    />
                    }
                </div>
            </div>
            <div className= "google-maps-root" id="google-maps-size">
                <MapComponent 
                    onMarkerDragEnd={(lat,lng,index)=>{
                        dispatch(setOnMarkerDragEnd(lat,lng,index));
                    }}
                    isStopsPage = {addStop}
                    enableLocationPick = {enableLocationPick}
                    setEnableLocationPick = {setEnableLocationPick}
                    onClickMap={(lat,lng)=>{
                        childRef.current(lat,lng);
                    }}
                    onCancel={()=>{
                        dispatch(resetAddressFromCache())
                    }}
                />
            </div>
        </div>
    )
} 